import { jsx } from "react/jsx-runtime";
import { useImageConfig } from "../../../utils/ImageConfigProvider/ImageConfigProviderClient.js";
import { getSwappedImageDomainUrl } from "../../../utils/images/lib.js";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { Link } from "@nxt-costco-com/forge-components";
import { ImageVideo } from "../ImageVideo/index.js";
import { getIsVideo, getStylesAspectRatio } from "../ImageVideo/lib.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import GenericImageHandler from "../../Util/GenericImageHandler.js";
import { getHeaderBackgroundStyle, StyledHeaderContainerSx, HeaderContainer, VideoStyles, OverlayIconContainer, HEADER_ICON_WIDTH, HEADER_ICON_HEIGHT } from "./styles.js";
const COMPONENT_NAME = "Header";
const Header = ({
  data,
  largeViewportFlexDirection,
  viewName,
  locale = "en-us"
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { imageDomainSwapConfig } = useImageConfig();
  if (!((_a = data == null ? void 0 : data.header_section) == null ? void 0 : _a.background_color)) {
    return null;
  }
  const {
    background_color,
    background_image,
    overlay_icon,
    use_overlay_icon
  } = data.header_section;
  const {
    background_color: singleBackgroundColor,
    background_gradient_style,
    background_gradient_color
  } = background_color;
  background_image == null ? void 0 : background_image.image;
  background_image == null ? void 0 : background_image.image_alt_text;
  const backgroundImageFirstObj = (_b = background_image == null ? void 0 : background_image.image) == null ? void 0 : _b[0];
  const backgroundImageFirstObjUrl = (_d = (_c = background_image == null ? void 0 : background_image.image) == null ? void 0 : _c[0]) == null ? void 0 : _d.url;
  const overlayIconImage = (_e = overlay_icon == null ? void 0 : overlay_icon.image) == null ? void 0 : _e[0];
  (overlay_icon == null ? void 0 : overlay_icon.image_alt_text) || "";
  const StyledHeaderContainer = ((_f = data.card_link) == null ? void 0 : _f.url) ? Link : CostcoBox;
  const { external_site, same_tab_domain } = data.card_link || {};
  const { target } = getLinkBehavior(external_site, same_tab_domain);
  const isVideo = getIsVideo(backgroundImageFirstObj);
  const backgroundImageUrl = !isVideo && getSwappedImageDomainUrl(
    backgroundImageFirstObjUrl,
    imageDomainSwapConfig
  );
  const aspectRatio = getStylesAspectRatio(backgroundImageFirstObj);
  const backgroundStyle = getHeaderBackgroundStyle(
    backgroundImageUrl || "",
    background_gradient_style,
    singleBackgroundColor,
    background_gradient_color
  );
  if (!isVideo && !backgroundStyle) {
    return null;
  }
  const renderOverlayIcon = () => {
    if (!use_overlay_icon || !overlayIconImage) return null;
    return /* @__PURE__ */ jsx(OverlayIconContainer, { children: /* @__PURE__ */ jsx(
      GenericImageHandler,
      {
        src: overlayIconImage == null ? void 0 : overlayIconImage.url,
        sx: {
          height: "auto",
          maxHeight: HEADER_ICON_HEIGHT,
          maxWidth: HEADER_ICON_WIDTH,
          width: "auto"
        },
        alt: (overlay_icon == null ? void 0 : overlay_icon.image_alt_text) || "",
        className: "overlay-icon",
        loading: "lazy",
        widths: [{ width: 1400 }]
      }
    ) });
  };
  const renderVideoContent = () => /* @__PURE__ */ jsx(
    HeaderContainer,
    {
      alignItems: "flex-end",
      backgroundStyle,
      "data-testid": `${viewName}-video-header`,
      largeViewportFlexDirection,
      children: /* @__PURE__ */ jsx(
        ImageVideo,
        {
          enableMobileImageVariation: false,
          image: background_image == null ? void 0 : background_image.image,
          imageAltText: background_image == null ? void 0 : background_image.image_alt_text,
          locale,
          imageSx: {
            height: "100%",
            width: "100%"
          },
          imageUrl: backgroundImageFirstObjUrl,
          sx: VideoStyles(largeViewportFlexDirection, aspectRatio)
        }
      )
    }
  );
  const renderStaticContent = () => /* @__PURE__ */ jsx(
    HeaderContainer,
    {
      backgroundStyle,
      "data-testid": `${viewName}-header`,
      largeViewportFlexDirection,
      children: renderOverlayIcon()
    }
  );
  return /* @__PURE__ */ jsx(
    StyledHeaderContainer,
    {
      sx: StyledHeaderContainerSx,
      href: (_g = data.card_link) == null ? void 0 : _g.url,
      target,
      children: isVideo ? renderVideoContent() : renderStaticContent()
    }
  );
};
Header.displayName = COMPONENT_NAME;
export {
  Header
};
